import {
    Button,
    Col,
    Drawer,
    Form,
    Input,
    Row,
    Select,
    Space,
    Spin
} from "antd";
import { Component } from "react";
import "../styles/general.css";

import { raw_menu } from "../constants/raw-list";
import { UPDATE } from "../constants/request-type";
import { role, update_role } from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "../functions/notification";

import logger from '../../utils/logger.js';
const token = sessionStorage.getItem("auth_token");

const { Option } = Select;

class Role_edit extends Component {
  state = {
    visible: false,
    name: this.props.row.name,
    list: [],
    locked: false,
    load: false
  };

  componentDidMount() {
    this.filterList();
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  filterList = () => {
    const val = this.filterListToGetValueOnly(this.props.row.list);
    if (val.includes("all")) {
      return this.setState({ locked: true });
    }
  };

  filterListToGetValueOnly = () => {
    const { list } = this.props.row;
    let arr = [];
    list.map((item) => {
      arr.push(item.name);
    });
    this.setState({ list: arr });
    return arr;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ load: true });

    const { name, list } = this.state;

    let newList = [];

    list.map((item) => {
      return newList.push({ name: item, _id: item });
    });

    const data = {
      name: name.toLowerCase(),
      list: newList
    };

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: role + "/" + update_role + "/" + this.props.row._id,
      data: data,
      token: token
    };

    if (data.name.length === 0 || data.list.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Vous devez remplir tous les champs"
      );
    }

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 0);
    } catch (err) {
      logger.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const { name, list, locked, load } = this.state;
    return (
      <>
        <Button type="danger" onClick={this.showDrawer}>
          Modifier role
        </Button>
        <Drawer
          title="Modification de role"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Annuler
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Soumettre
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                 
                  label="Nom"
                  rules={[
                    { required: true, role: "Veuillez entrer le nom du role" }
                  ]}
                >
                  <Input
                    name="name"
                    placeholder="Veuillez entrer le nom du role"
                    onChange={this.handleChange}
                    value={name}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: "100%" }}
                  placeholder="Selectionner parmis les options"
                  defaultValue={list}
                  onChange={(data) => {
                    if (data.includes("all")) {
                      logger.log(data);
                      return this.setState({
                        locked: true,
                        list: ["all"]
                      });
                    }
                    return this.setState({ locked: false, list: data });
                  }}
                >
                  <Option key={"all"}>
                    <span>Tout</span>
                  </Option>
                  {raw_menu
                    .filter((data) => {
                      if (locked) return false;
                      return true;
                    })
                    .map((item) => (
                      <Option key={item.value}>
                        <span>{item.name}</span>
                      </Option>
                    ))}
                </Select>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Role_edit;
